module.exports = __webpack_public_path__ + "static/Crawford-034da23e20228a52583ad7e922965eaa.jpg";